var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessGoals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 398.315,
    height: 374.45,
    viewBox: "0 0 398.315 374.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Business_Goals",
    "data-name": "Business Goals",
    transform: "translate(-14.883 -25.5)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(15.383 394.996)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 391.132,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plants",
    transform: "translate(18.143 240.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6268",
    "data-name": "Group 6268",
    transform: "translate(327.699 73.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M410.9,391.131c1.879.821,6.476.717,6.479.717.047,0-.988-3.009-1.075-3.191-1.009-2.11-4.2-5.593-6.793-5.243a3.1,3.1,0,0,0-2.487,3.884C407.452,389.1,409.3,390.431,410.9,391.131Z",
    transform: "translate(-406.927 -370.058)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M412.556,401.981c1.949.284,6.051-.906,6.377-1a55.016,55.016,0,0,0,2.488,6.884c.564,1.307,1.173,2.605,1.8,3.9-.374-.549-.713-1.036-.767-1.1-1.53-1.768-5.526-4.286-7.937-3.262a3.1,3.1,0,0,0-1.373,4.4c.89,1.621,3.022,2.421,4.751,2.673,1.754.256,5.272-.688,6.2-.95.246.494.485.99.733,1.483,1.188,2.365,2.383,4.72,3.486,7.066.389.827.741,1.655,1.1,2.483-.333-.487-.617-.894-.667-.951-1.53-1.768-5.526-4.287-7.937-3.263a3.1,3.1,0,0,0-1.373,4.4c.891,1.62,3.023,2.421,4.751,2.673,1.674.244,4.929-.6,6.032-.9.338.858.68,1.718.969,2.565.185.583.4,1.131.556,1.727l.486,1.742c.268,1.119.552,2.272.787,3.37.169.763.316,1.493.465,2.227-.376-.827-1.15-2.432-1.23-2.558-1.244-1.98-4.812-5.073-7.35-4.427a3.1,3.1,0,0,0-2.025,4.144c.635,1.736,2.621,2.851,4.291,3.362,1.839.562,5.911.048,6.419-.019.244,1.217.469,2.4.664,3.525.4,2.28.711,4.336.955,6.115h1.708c-.29-1.845-.661-4-1.138-6.4-.242-1.236-.527-2.552-.831-3.9a34.037,34.037,0,0,0,3.581-1.684c1.34,1.451,4.775,3.15,5.219,3.366-.468,1.15-.933,2.263-1.389,3.307-.863,1.987-1.686,3.765-2.427,5.312h1.841c.629-1.407,1.309-2.98,2.015-4.709.48-1.165.969-2.42,1.459-3.713.493.1,4.523.922,6.4.5,1.7-.386,3.767-1.349,4.53-3.033a3.1,3.1,0,0,0-1.711-4.283c-2.482-.834-6.271,1.985-7.659,3.867-.083.111-.836,1.415-1.3,2.245.2-.529.4-1.041.593-1.588.4-1.08.76-2.169,1.155-3.34q.257-.857.518-1.733c.186-.575.308-1.206.467-1.814.338-1.418.611-2.87.853-4.341.947.344,4.325,1.52,6.076,1.4s3.928-.762,4.936-2.312a3.1,3.1,0,0,0-1.042-4.493c-2.328-1.2-6.5,1.013-8.158,2.662-.1.1-1.16,1.42-1.726,2.155.139-.885.283-1.767.394-2.666.322-2.6.567-5.234.824-7.866.078-.806.166-1.608.251-2.411.335.127,4.321,1.61,6.282,1.473,1.742-.122,3.927-.762,4.937-2.312a3.1,3.1,0,0,0-1.042-4.493c-2.328-1.2-6.5,1.012-8.158,2.662-.125.124-1.642,2.021-2,2.524.187-1.769.39-3.53.661-5.258a54.7,54.7,0,0,1,1.509-6.917c.156.059,4.309,1.627,6.317,1.486,1.742-.122,3.928-.763,4.936-2.312a3.1,3.1,0,0,0-1.042-4.493c-2.328-1.2-6.5,1.013-8.157,2.662-.131.13-1.761,2.172-2.031,2.564.039-.132.064-.272.1-.4a39.971,39.971,0,0,1,2.74-6.544c.6-1.166,1.23-2.246,1.871-3.284.744.371,4.16,2.031,5.981,2.1,1.745.07,3.988-.327,5.16-1.755a3.1,3.1,0,0,0-.541-4.58c-2.182-1.449-6.572.292-8.4,1.75-.1.079-1.021,1-1.683,1.675.3-.463.594-.948.886-1.387,1.1-1.649,2.2-3.092,3.189-4.363.568-.718,1.1-1.355,1.6-1.947.92-.016,4.626-.129,6.246-.89,1.581-.743,3.389-2.128,3.771-3.936a3.1,3.1,0,0,0-2.591-3.815c-2.6-.28-5.7,3.287-6.649,5.424-.082.185-1.036,3.219-.988,3.219h.056c-.493.56-1.014,1.166-1.572,1.838-1.019,1.252-2.158,2.675-3.294,4.307a55.05,55.05,0,0,0-3.414,5.44,40.386,40.386,0,0,0-2.918,6.566c-.008.027-.014.056-.024.083.014-.766-.02-2.913-.041-3.077-.3-2.319-2.244-6.624-4.82-7.1a3.1,3.1,0,0,0-3.574,2.915c-.15,1.842,1.185,3.687,2.488,4.85,1.469,1.312,5.547,2.583,5.872,2.682a54.906,54.906,0,0,0-1.723,7.115c-.251,1.4-.458,2.82-.649,4.245-.01-.664-.024-1.258-.035-1.34-.3-2.319-2.244-6.623-4.819-7.1A3.1,3.1,0,0,0,441.5,406c-.151,1.842,1.186,3.687,2.488,4.85,1.322,1.181,4.777,2.334,5.7,2.627-.068.548-.141,1.094-.207,1.642-.314,2.628-.615,5.252-.991,7.817-.132.9-.294,1.789-.455,2.675-.009-.59-.022-1.086-.031-1.161-.3-2.319-2.245-6.624-4.82-7.1a3.1,3.1,0,0,0-3.574,2.915c-.151,1.842,1.186,3.687,2.488,4.85,1.261,1.127,4.44,2.22,5.53,2.572-.191.9-.381,1.808-.607,2.674-.167.587-.288,1.166-.489,1.747s-.372,1.153-.556,1.721c-.393,1.082-.793,2.2-1.2,3.245-.28.729-.56,1.419-.84,2.114.142-.9.382-2.663.385-2.812a12.03,12.03,0,0,0-1.614-5.854,3.65,3.65,0,0,0-.042-.685,3.1,3.1,0,0,0-3.79-2.629c-2.53.673-4.136,5.115-4.255,7.452-.007.138.084,1.641.156,2.588-.128-.551-.245-1.086-.383-1.652-.265-1.119-.563-2.228-.879-3.423q-.258-.857-.523-1.731c-.163-.582-.409-1.176-.611-1.771-.5-1.368-1.074-2.731-1.683-4.091.979-.235,4.446-1.118,5.838-2.186s2.855-2.8,2.842-4.652a3.1,3.1,0,0,0-3.347-3.173c-2.6.283-4.862,4.43-5.335,6.721-.03.143-.184,1.824-.251,2.75-.372-.815-.739-1.63-1.143-2.442-1.164-2.343-2.415-4.679-3.652-7.015-.38-.715-.749-1.432-1.122-2.149.349-.079,4.493-1.041,6.051-2.237,1.386-1.063,2.856-2.8,2.843-4.651a3.1,3.1,0,0,0-3.347-3.173c-2.6.282-4.862,4.43-5.336,6.72-.035.173-.253,2.593-.279,3.21-.819-1.578-1.622-3.159-2.35-4.749a54.537,54.537,0,0,1-2.556-6.6c.163-.037,4.492-1.02,6.089-2.246,1.386-1.063,2.855-2.8,2.842-4.651a3.1,3.1,0,0,0-3.347-3.173c-2.6.283-4.862,4.43-5.335,6.72-.037.181-.271,2.783-.279,3.259-.041-.131-.1-.262-.136-.393a39.98,39.98,0,0,1-1.324-6.97c-.146-1.3-.214-2.552-.251-3.771.825-.1,4.59-.6,6.149-1.545,1.493-.9,3.145-2.472,3.335-4.311a3.1,3.1,0,0,0-2.978-3.521c-2.619-.005-5.32,3.869-6.041,6.094-.039.121-.3,1.4-.48,2.325-.008-.55-.027-1.118-.025-1.646,0-1.98.129-3.793.253-5.4.078-.912.166-1.735.257-2.5.758-.522,3.787-2.659,4.718-4.188.909-1.491,1.653-3.644.974-5.364a3.1,3.1,0,0,0-4.265-1.752c-2.327,1.2-2.939,5.885-2.554,8.193.034.2.912,3.257.952,3.23l.046-.031c-.1.738-.2,1.531-.3,2.4-.159,1.606-.325,3.422-.371,5.409a55.067,55.067,0,0,0,.154,6.421,40.389,40.389,0,0,0,1.189,7.087c.008.027.019.055.026.082-.412-.647-1.625-2.418-1.733-2.544-1.53-1.769-5.526-4.287-7.937-3.263a3.1,3.1,0,0,0-1.373,4.4C408.7,400.929,410.827,401.729,412.556,401.981Z",
    transform: "translate(-406.999 -367.593)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M465.545,391.6c.041.025.836-3.054.863-3.254.323-2.317-.415-6.981-2.773-8.121a3.1,3.1,0,0,0-4.216,1.868c-.633,1.737.169,3.869,1.118,5.335C461.651,389.152,465.541,391.6,465.545,391.6Z",
    transform: "translate(-415.081 -369.518)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6269",
    "data-name": "Group 6269",
    transform: "translate(294.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M370.489,296.928a15.857,15.857,0,0,0,4.63.512c.034,0-.706-2.15-.768-2.28-.722-1.507-3-4-4.855-3.746a2.216,2.216,0,0,0-1.777,2.776A4.629,4.629,0,0,0,370.489,296.928Z",
    transform: "translate(-367.652 -281.87)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M371.673,304.682a15.37,15.37,0,0,0,4.558-.716,39.287,39.287,0,0,0,1.777,4.92c.4.933.839,1.861,1.287,2.786-.268-.392-.51-.74-.549-.785-1.094-1.264-3.949-3.063-5.672-2.332a2.215,2.215,0,0,0-.981,3.146,4.626,4.626,0,0,0,3.395,1.91,14.657,14.657,0,0,0,4.429-.679c.176.354.348.707.524,1.06.849,1.69,1.7,3.373,2.491,5.05.278.591.53,1.182.784,1.774-.238-.349-.441-.639-.477-.68-1.093-1.263-3.948-3.063-5.671-2.331a2.214,2.214,0,0,0-.982,3.146,4.633,4.633,0,0,0,3.395,1.91,14.147,14.147,0,0,0,4.31-.646c.242.614.486,1.227.693,1.832.132.417.288.809.4,1.234l.348,1.245c.192.8.4,1.624.562,2.409.121.544.225,1.066.332,1.591-.269-.591-.822-1.737-.879-1.828-.889-1.414-3.439-3.625-5.253-3.163a2.215,2.215,0,0,0-1.447,2.962,4.631,4.631,0,0,0,3.066,2.4,15.21,15.21,0,0,0,4.587-.013c.174.869.336,1.717.475,2.518.287,1.629.508,3.1.681,4.369h1.221c-.208-1.318-.473-2.861-.813-4.574-.173-.883-.376-1.824-.594-2.788a23.893,23.893,0,0,0,2.559-1.2,16.212,16.212,0,0,0,3.73,2.406c-.334.821-.668,1.616-.993,2.362-.617,1.42-1.205,2.691-1.734,3.8h1.316c.449-1.006.935-2.13,1.44-3.365.343-.832.692-1.729,1.042-2.653a15.241,15.241,0,0,0,4.575.355,4.631,4.631,0,0,0,3.237-2.167,2.214,2.214,0,0,0-1.223-3.06c-1.773-.6-4.481,1.419-5.473,2.763-.058.079-.6,1.011-.928,1.6.141-.379.282-.744.423-1.135.283-.772.543-1.55.825-2.387l.371-1.239c.133-.41.22-.861.333-1.3.24-1.013.436-2.052.609-3.1a14.546,14.546,0,0,0,4.341,1,4.63,4.63,0,0,0,3.528-1.652,2.215,2.215,0,0,0-.744-3.211c-1.664-.858-4.645.724-5.83,1.9-.073.073-.829,1.015-1.233,1.54.1-.632.2-1.263.281-1.906.23-1.855.406-3.741.589-5.62.056-.576.119-1.15.179-1.723a15.4,15.4,0,0,0,4.488,1.052,4.628,4.628,0,0,0,3.528-1.652,2.215,2.215,0,0,0-.744-3.211c-1.663-.857-4.644.723-5.829,1.9-.089.089-1.174,1.444-1.432,1.8.133-1.264.278-2.522.472-3.757a38.9,38.9,0,0,1,1.078-4.942,15.657,15.657,0,0,0,4.514,1.062,4.632,4.632,0,0,0,3.528-1.653,2.214,2.214,0,0,0-.744-3.21c-1.663-.858-4.644.723-5.829,1.9-.093.093-1.258,1.552-1.451,1.832.028-.094.046-.194.074-.288a28.567,28.567,0,0,1,1.958-4.677c.425-.832.879-1.6,1.337-2.346a14.922,14.922,0,0,0,4.274,1.5,4.632,4.632,0,0,0,3.688-1.254,2.215,2.215,0,0,0-.387-3.273c-1.559-1.036-4.7.209-6,1.25-.071.057-.73.712-1.2,1.2.212-.331.425-.677.633-.991.783-1.178,1.572-2.21,2.28-3.118.406-.513.783-.968,1.14-1.391a14.838,14.838,0,0,0,4.463-.636,4.628,4.628,0,0,0,2.694-2.813,2.214,2.214,0,0,0-1.852-2.726c-1.86-.2-4.071,2.35-4.751,3.876-.058.132-.74,2.3-.706,2.3h.04c-.353.4-.726.832-1.123,1.313-.728.894-1.542,1.911-2.354,3.077a39.461,39.461,0,0,0-2.44,3.887,28.864,28.864,0,0,0-2.084,4.693c-.007.019-.011.04-.018.059.01-.548-.014-2.081-.03-2.2-.214-1.657-1.6-4.732-3.443-5.073A2.216,2.216,0,0,0,394.1,298a4.634,4.634,0,0,0,1.777,3.466,15.39,15.39,0,0,0,4.2,1.917,39.257,39.257,0,0,0-1.231,5.084c-.179,1-.328,2.015-.464,3.033-.007-.474-.017-.9-.025-.957-.215-1.658-1.6-4.733-3.444-5.073a2.214,2.214,0,0,0-2.554,2.082,4.627,4.627,0,0,0,1.777,3.466,14.661,14.661,0,0,0,4.07,1.877c-.048.392-.1.781-.148,1.173-.224,1.878-.44,3.753-.708,5.586-.094.646-.211,1.279-.325,1.912-.007-.421-.015-.776-.023-.83-.214-1.657-1.6-4.733-3.444-5.073A2.216,2.216,0,0,0,391,317.749a4.632,4.632,0,0,0,1.778,3.466,14.128,14.128,0,0,0,3.951,1.838c-.137.645-.272,1.292-.434,1.911-.12.42-.206.833-.349,1.248l-.4,1.23c-.281.773-.566,1.572-.86,2.319-.2.521-.4,1.014-.6,1.51.1-.641.273-1.9.275-2.009a8.6,8.6,0,0,0-1.153-4.184,2.639,2.639,0,0,0-.03-.489,2.215,2.215,0,0,0-2.708-1.879c-1.808.482-2.955,3.655-3.041,5.325-.005.1.06,1.172.111,1.849-.091-.393-.175-.776-.273-1.18-.19-.8-.4-1.592-.629-2.446l-.374-1.237c-.116-.415-.292-.84-.437-1.265-.357-.977-.767-1.951-1.2-2.923a14.559,14.559,0,0,0,4.171-1.562,4.628,4.628,0,0,0,2.032-3.324,2.215,2.215,0,0,0-2.392-2.267c-1.86.2-3.475,3.166-3.812,4.8-.021.1-.132,1.3-.18,1.965-.266-.582-.528-1.164-.816-1.745-.831-1.674-1.725-3.343-2.61-5.012-.271-.511-.535-1.024-.8-1.536a15.359,15.359,0,0,0,4.325-1.6,4.631,4.631,0,0,0,2.032-3.324,2.215,2.215,0,0,0-2.392-2.268c-1.861.2-3.475,3.166-3.813,4.8-.025.124-.181,1.853-.2,2.295-.586-1.128-1.16-2.258-1.68-3.395a38.921,38.921,0,0,1-1.826-4.717,15.64,15.64,0,0,0,4.35-1.6,4.627,4.627,0,0,0,2.031-3.324,2.215,2.215,0,0,0-2.392-2.268c-1.861.2-3.475,3.166-3.812,4.8-.027.129-.194,1.989-.2,2.329-.029-.094-.069-.187-.1-.281a28.608,28.608,0,0,1-.946-4.98c-.1-.929-.153-1.824-.179-2.695a14.9,14.9,0,0,0,4.394-1.1,4.629,4.629,0,0,0,2.383-3.081,2.213,2.213,0,0,0-2.128-2.516c-1.871,0-3.8,2.765-4.316,4.354-.029.086-.216,1-.343,1.662-.006-.393-.019-.8-.018-1.177,0-1.415.092-2.71.181-3.857.056-.652.119-1.24.184-1.79a14.821,14.821,0,0,0,3.372-2.992,4.631,4.631,0,0,0,.7-3.833,2.215,2.215,0,0,0-3.048-1.253c-1.663.859-2.1,4.206-1.825,5.854.024.143.652,2.328.68,2.308l.033-.022c-.073.527-.145,1.094-.212,1.715-.114,1.147-.232,2.444-.265,3.865a39.387,39.387,0,0,0,.109,4.588,28.928,28.928,0,0,0,.85,5.064c.006.019.013.039.019.058-.294-.463-1.16-1.728-1.238-1.818-1.093-1.263-3.948-3.063-5.671-2.331a2.215,2.215,0,0,0-.982,3.146A4.627,4.627,0,0,0,371.673,304.682Z",
    transform: "translate(-367.703 -280.109)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M409.538,297.266c.03.019.6-2.183.618-2.326.23-1.655-.3-4.988-1.983-5.8a2.214,2.214,0,0,0-3.013,1.334,4.629,4.629,0,0,0,.8,3.812A15.846,15.846,0,0,0,409.538,297.266Z",
    transform: "translate(-373.479 -281.485)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6270",
    "data-name": "Group 6270",
    transform: "translate(0 73.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M91.956,391.131c-1.879.821-6.475.717-6.478.717-.048,0,.987-3.009,1.074-3.191,1.009-2.11,4.2-5.593,6.793-5.243a3.1,3.1,0,0,1,2.487,3.884C95.4,389.1,93.557,390.431,91.956,391.131Z",
    transform: "translate(-29.078 -370.058)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M79.945,401.981c-1.95.284-6.051-.906-6.378-1a54.756,54.756,0,0,1-2.488,6.884c-.564,1.307-1.173,2.605-1.8,3.9.374-.549.713-1.036.767-1.1,1.531-1.768,5.526-4.286,7.937-3.262a3.1,3.1,0,0,1,1.373,4.4c-.89,1.621-3.022,2.421-4.751,2.673-1.753.256-5.272-.688-6.2-.95-.246.494-.485.99-.733,1.483-1.187,2.365-2.383,4.72-3.485,7.066-.389.827-.741,1.655-1.1,2.483.333-.487.617-.894.667-.951,1.53-1.768,5.526-4.287,7.937-3.263a3.1,3.1,0,0,1,1.373,4.4c-.89,1.62-3.022,2.421-4.751,2.673-1.674.244-4.928-.6-6.032-.9-.338.858-.679,1.718-.969,2.565-.185.583-.4,1.131-.555,1.727s-.326,1.167-.487,1.742c-.268,1.119-.552,2.272-.786,3.37-.17.763-.316,1.493-.466,2.227.377-.827,1.15-2.432,1.23-2.558,1.245-1.98,4.812-5.073,7.351-4.427a3.1,3.1,0,0,1,2.024,4.144c-.635,1.736-2.621,2.851-4.291,3.362-1.839.562-5.91.048-6.419-.019-.244,1.217-.47,2.4-.665,3.525-.4,2.28-.711,4.336-.954,6.115H55.59c.289-1.845.66-4,1.137-6.4.242-1.236.527-2.552.831-3.9a33.961,33.961,0,0,1-3.581-1.684c-1.34,1.451-4.775,3.15-5.22,3.366.468,1.15.933,2.263,1.39,3.307.863,1.987,1.686,3.765,2.427,5.312H50.733c-.629-1.407-1.308-2.98-2.015-4.709-.479-1.165-.969-2.42-1.459-3.713-.492.1-4.523.922-6.4.5-1.7-.386-3.767-1.349-4.529-3.033a3.1,3.1,0,0,1,1.71-4.283c2.482-.834,6.272,1.985,7.66,3.867.082.111.836,1.415,1.3,2.245-.2-.529-.395-1.041-.592-1.588-.4-1.08-.76-2.169-1.155-3.34q-.257-.857-.518-1.733c-.185-.575-.308-1.206-.467-1.814-.337-1.418-.61-2.87-.853-4.341-.946.344-4.325,1.52-6.075,1.4s-3.928-.762-4.936-2.312a3.1,3.1,0,0,1,1.041-4.493c2.328-1.2,6.5,1.013,8.158,2.662.1.1,1.16,1.42,1.726,2.155-.139-.885-.282-1.767-.393-2.666-.322-2.6-.568-5.234-.825-7.866-.078-.806-.165-1.608-.25-2.411-.336.127-4.322,1.61-6.282,1.473-1.743-.122-3.928-.762-4.936-2.312a3.1,3.1,0,0,1,1.041-4.493c2.327-1.2,6.5,1.012,8.157,2.662.125.124,1.642,2.021,2,2.524-.187-1.769-.39-3.53-.66-5.258a54.549,54.549,0,0,0-1.51-6.917c-.156.059-4.309,1.627-6.316,1.486-1.743-.122-3.928-.763-4.937-2.312a3.1,3.1,0,0,1,1.041-4.493c2.328-1.2,6.5,1.013,8.158,2.662.13.13,1.761,2.172,2.031,2.564-.039-.132-.065-.272-.1-.4a39.973,39.973,0,0,0-2.74-6.544c-.6-1.166-1.231-2.246-1.871-3.284-.744.371-4.161,2.031-5.981,2.1-1.745.07-3.988-.327-5.161-1.755a3.1,3.1,0,0,1,.542-4.58c2.182-1.449,6.571.292,8.4,1.75.1.079,1.021,1,1.683,1.675-.3-.463-.593-.948-.886-1.387-1.1-1.649-2.2-3.092-3.189-4.363-.568-.718-1.1-1.355-1.6-1.947-.92-.016-4.625-.129-6.246-.89-1.581-.743-3.389-2.128-3.771-3.936a3.1,3.1,0,0,1,2.592-3.815c2.6-.28,5.7,3.287,6.649,5.424.082.185,1.036,3.219.987,3.219H28.9c.493.56,1.015,1.166,1.572,1.838,1.018,1.252,2.157,2.675,3.293,4.307a55.046,55.046,0,0,1,3.415,5.44,40.452,40.452,0,0,1,2.917,6.566c.009.027.014.056.024.083-.014-.766.02-2.913.042-3.077.3-2.319,2.244-6.624,4.819-7.1a3.1,3.1,0,0,1,3.574,2.915c.151,1.842-1.185,3.687-2.487,4.85-1.469,1.312-5.547,2.583-5.872,2.682a55.037,55.037,0,0,1,1.723,7.115c.25,1.4.458,2.82.649,4.245.009-.664.023-1.258.034-1.34.3-2.319,2.245-6.623,4.82-7.1A3.1,3.1,0,0,1,51,406c.151,1.842-1.185,3.687-2.488,4.85-1.322,1.181-4.776,2.334-5.694,2.627.068.548.141,1.094.206,1.642.314,2.628.616,5.252.992,7.817.131.9.295,1.789.454,2.675.009-.59.022-1.086.032-1.161.3-2.319,2.244-6.624,4.819-7.1a3.1,3.1,0,0,1,3.574,2.915c.151,1.842-1.185,3.687-2.487,4.85-1.262,1.127-4.441,2.22-5.531,2.572.192.9.381,1.808.607,2.674.168.587.288,1.166.49,1.747q.28.87.555,1.721c.393,1.082.793,2.2,1.2,3.245.28.729.56,1.419.841,2.114-.142-.9-.382-2.663-.386-2.812a12.03,12.03,0,0,1,1.614-5.854,3.653,3.653,0,0,1,.043-.685,3.1,3.1,0,0,1,3.79-2.629c2.53.673,4.136,5.115,4.255,7.452.008.138-.083,1.641-.155,2.588.127-.551.245-1.086.382-1.652.266-1.119.563-2.228.879-3.423q.258-.857.524-1.731c.162-.582.408-1.176.611-1.771.5-1.368,1.074-2.731,1.682-4.091-.979-.235-4.445-1.118-5.837-2.186s-2.856-2.8-2.843-4.652a3.1,3.1,0,0,1,3.347-3.173c2.6.283,4.863,4.43,5.336,6.721.03.143.184,1.824.251,2.75.372-.815.739-1.63,1.142-2.442,1.164-2.343,2.415-4.679,3.652-7.015.38-.715.749-1.432,1.123-2.149-.35-.079-4.493-1.041-6.052-2.237-1.386-1.063-2.855-2.8-2.843-4.651a3.1,3.1,0,0,1,3.347-3.173c2.6.282,4.863,4.43,5.336,6.72.035.173.254,2.593.279,3.21.82-1.578,1.622-3.159,2.351-4.749a54.537,54.537,0,0,0,2.556-6.6c-.162-.037-4.491-1.02-6.088-2.246-1.386-1.063-2.856-2.8-2.843-4.651a3.1,3.1,0,0,1,3.347-3.173c2.6.283,4.863,4.43,5.335,6.72.038.181.271,2.783.28,3.259.041-.131.1-.262.135-.393a39.987,39.987,0,0,0,1.325-6.97c.146-1.3.213-2.552.251-3.771-.825-.1-4.59-.6-6.149-1.545-1.494-.9-3.146-2.472-3.336-4.311a3.1,3.1,0,0,1,2.979-3.521c2.618-.005,5.32,3.869,6.04,6.094.04.121.3,1.4.48,2.325.008-.55.028-1.118.025-1.646,0-1.98-.129-3.793-.253-5.4-.078-.912-.166-1.735-.257-2.5-.758-.522-3.787-2.659-4.719-4.188-.909-1.491-1.653-3.644-.974-5.364a3.1,3.1,0,0,1,4.266-1.752c2.327,1.2,2.938,5.885,2.553,8.193-.033.2-.912,3.257-.951,3.23l-.046-.031c.1.738.2,1.531.3,2.4.159,1.606.324,3.422.371,5.409a54.879,54.879,0,0,1-.153,6.421,40.468,40.468,0,0,1-1.189,7.087c-.008.027-.019.055-.026.082.411-.647,1.624-2.418,1.733-2.544,1.53-1.769,5.526-4.287,7.936-3.263a3.1,3.1,0,0,1,1.373,4.4C83.8,400.929,81.673,401.729,79.945,401.981Z",
    transform: "translate(-18.653 -367.593)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M37.893,391.6c-.04.025-.836-3.054-.863-3.254-.322-2.317.415-6.981,2.773-8.121a3.1,3.1,0,0,1,4.217,1.868c.632,1.737-.17,3.869-1.118,5.335C41.787,389.152,37.9,391.6,37.893,391.6Z",
    transform: "translate(-21.509 -369.518)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6271",
    "data-name": "Group 6271",
    transform: "translate(52.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M132.916,296.928a15.849,15.849,0,0,1-4.629.512c-.035,0,.706-2.15.768-2.28.721-1.507,3-4,4.854-3.746a2.215,2.215,0,0,1,1.777,2.776A4.627,4.627,0,0,1,132.916,296.928Z",
    transform: "translate(-87.985 -281.87)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M124.333,304.682a15.374,15.374,0,0,1-4.558-.716,39.167,39.167,0,0,1-1.777,4.92c-.4.933-.838,1.861-1.286,2.786.267-.392.509-.74.548-.785,1.094-1.264,3.949-3.063,5.672-2.332a2.215,2.215,0,0,1,.982,3.146,4.628,4.628,0,0,1-3.4,1.91,14.662,14.662,0,0,1-4.429-.679c-.176.354-.347.707-.524,1.06-.849,1.69-1.7,3.373-2.491,5.05-.278.591-.529,1.182-.784,1.774.238-.349.441-.639.477-.68,1.093-1.263,3.949-3.063,5.672-2.331a2.214,2.214,0,0,1,.981,3.146,4.633,4.633,0,0,1-3.395,1.91,14.151,14.151,0,0,1-4.31-.646c-.242.614-.486,1.227-.692,1.832-.133.417-.288.809-.4,1.234s-.233.835-.348,1.245c-.192.8-.394,1.624-.561,2.409-.122.544-.226,1.066-.333,1.591.27-.591.822-1.737.879-1.828.889-1.414,3.438-3.625,5.252-3.163a2.215,2.215,0,0,1,1.447,2.962,4.629,4.629,0,0,1-3.066,2.4,15.2,15.2,0,0,1-4.586-.013c-.175.869-.336,1.717-.475,2.518-.288,1.629-.509,3.1-.682,4.369h-1.22c.207-1.318.472-2.861.812-4.574.174-.883.376-1.824.594-2.788a23.976,23.976,0,0,1-2.559-1.2,16.229,16.229,0,0,1-3.73,2.406c.334.821.667,1.616.993,2.362.617,1.42,1.2,2.691,1.734,3.8H103.46c-.45-1.006-.935-2.13-1.441-3.365-.343-.832-.692-1.729-1.042-2.653a15.234,15.234,0,0,1-4.574.355,4.631,4.631,0,0,1-3.237-2.167,2.214,2.214,0,0,1,1.222-3.06c1.774-.6,4.482,1.419,5.473,2.763.059.079.6,1.011.928,1.6-.142-.379-.283-.744-.424-1.135-.283-.772-.543-1.55-.825-2.387q-.184-.613-.37-1.239c-.133-.41-.22-.861-.333-1.3-.241-1.013-.437-2.052-.61-3.1a14.54,14.54,0,0,1-4.341,1,4.629,4.629,0,0,1-3.527-1.652,2.215,2.215,0,0,1,.744-3.211c1.664-.858,4.645.724,5.829,1.9.074.073.829,1.015,1.233,1.54-.1-.632-.2-1.263-.281-1.906-.23-1.855-.406-3.741-.589-5.62-.056-.576-.118-1.15-.179-1.723a15.388,15.388,0,0,1-4.488,1.052A4.631,4.631,0,0,1,89.1,311.82a2.215,2.215,0,0,1,.744-3.211c1.664-.857,4.645.723,5.829,1.9.089.089,1.173,1.444,1.432,1.8-.134-1.264-.279-2.522-.472-3.757a39.052,39.052,0,0,0-1.079-4.942,15.649,15.649,0,0,1-4.514,1.062,4.629,4.629,0,0,1-3.528-1.653,2.214,2.214,0,0,1,.744-3.21c1.663-.858,4.644.723,5.829,1.9.094.093,1.258,1.552,1.451,1.832-.027-.094-.046-.194-.074-.288a28.49,28.49,0,0,0-1.958-4.677c-.425-.832-.879-1.6-1.337-2.346a14.9,14.9,0,0,1-4.274,1.5,4.63,4.63,0,0,1-3.687-1.254,2.215,2.215,0,0,1,.387-3.273c1.559-1.036,4.7.209,6,1.25.071.057.729.712,1.2,1.2-.212-.331-.425-.677-.634-.991-.783-1.178-1.572-2.21-2.279-3.118-.406-.513-.783-.968-1.14-1.391a14.835,14.835,0,0,1-4.463-.636,4.629,4.629,0,0,1-2.695-2.813,2.215,2.215,0,0,1,1.852-2.726c1.86-.2,4.071,2.35,4.751,3.876.059.132.741,2.3.706,2.3h-.04c.352.4.725.832,1.123,1.313.728.894,1.541,1.911,2.353,3.077a39.471,39.471,0,0,1,2.44,3.887,28.94,28.94,0,0,1,2.085,4.693c.007.019.01.04.017.059-.01-.548.014-2.081.03-2.2.215-1.657,1.6-4.732,3.444-5.073A2.215,2.215,0,0,1,101.9,298a4.628,4.628,0,0,1-1.777,3.466,15.378,15.378,0,0,1-4.2,1.917,39.122,39.122,0,0,1,1.231,5.084c.179,1,.327,2.015.463,3.033.008-.474.017-.9.024-.957.215-1.658,1.6-4.733,3.444-5.073a2.214,2.214,0,0,1,2.554,2.082,4.627,4.627,0,0,1-1.777,3.466A14.669,14.669,0,0,1,97.8,312.9c.048.392.1.781.147,1.173.225,1.878.441,3.753.708,5.586.095.646.211,1.279.325,1.912.007-.421.016-.776.023-.83.214-1.657,1.6-4.733,3.444-5.073A2.215,2.215,0,0,1,105,317.749a4.631,4.631,0,0,1-1.777,3.466,14.123,14.123,0,0,1-3.952,1.838c.137.645.273,1.292.434,1.911.12.42.206.833.349,1.248s.266.824.4,1.23c.281.773.566,1.572.859,2.319.2.521.4,1.014.6,1.51-.1-.641-.273-1.9-.275-2.009a8.609,8.609,0,0,1,1.153-4.184,2.642,2.642,0,0,1,.031-.489,2.215,2.215,0,0,1,2.708-1.879c1.809.482,2.956,3.655,3.041,5.325.005.1-.059,1.172-.111,1.849.091-.393.176-.776.274-1.18.189-.8.4-1.592.628-2.446l.374-1.237c.116-.415.292-.84.437-1.265.358-.977.768-1.951,1.2-2.923a14.554,14.554,0,0,1-4.172-1.562,4.627,4.627,0,0,1-2.031-3.324,2.215,2.215,0,0,1,2.392-2.267c1.86.2,3.475,3.166,3.812,4.8.021.1.131,1.3.179,1.965.266-.582.528-1.164.816-1.745.831-1.674,1.726-3.343,2.61-5.012.272-.511.535-1.024.8-1.536a15.369,15.369,0,0,1-4.325-1.6,4.629,4.629,0,0,1-2.031-3.324,2.215,2.215,0,0,1,2.392-2.268c1.86.2,3.475,3.166,3.812,4.8.025.124.181,1.853.2,2.295.586-1.128,1.159-2.258,1.679-3.395a38.922,38.922,0,0,0,1.827-4.717,15.633,15.633,0,0,1-4.351-1.6,4.627,4.627,0,0,1-2.031-3.324,2.215,2.215,0,0,1,2.391-2.268c1.861.2,3.476,3.166,3.813,4.8.026.129.193,1.989.2,2.329.03-.094.069-.187.1-.281a28.539,28.539,0,0,0,.947-4.98c.1-.929.152-1.824.179-2.695a14.887,14.887,0,0,1-4.394-1.1,4.63,4.63,0,0,1-2.384-3.081,2.214,2.214,0,0,1,2.129-2.516c1.871,0,3.8,2.765,4.317,4.354.028.086.215,1,.343,1.662.006-.393.019-.8.019-1.177,0-1.415-.093-2.71-.181-3.857-.056-.652-.119-1.24-.184-1.79a14.8,14.8,0,0,1-3.372-2.992,4.631,4.631,0,0,1-.7-3.833,2.215,2.215,0,0,1,3.049-1.253c1.663.859,2.1,4.206,1.825,5.854-.024.143-.652,2.328-.68,2.308l-.032-.022c.073.527.145,1.094.211,1.715.114,1.147.232,2.444.266,3.865a39.211,39.211,0,0,1-.11,4.588,28.851,28.851,0,0,1-.85,5.064c-.005.019-.014.039-.019.058.294-.463,1.16-1.728,1.238-1.818,1.093-1.263,3.949-3.063,5.671-2.331a2.214,2.214,0,0,1,.982,3.146A4.627,4.627,0,0,1,124.333,304.682Z",
    transform: "translate(-80.536 -280.109)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M94.284,297.266c-.029.019-.6-2.183-.617-2.326-.231-1.655.3-4.988,1.982-5.8a2.214,2.214,0,0,1,3.013,1.334,4.625,4.625,0,0,1-.8,3.812A15.827,15.827,0,0,1,94.284,297.266Z",
    transform: "translate(-82.577 -281.485)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Stairs",
    transform: "translate(50.572 97.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6276",
    "data-name": "Group 6276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M273.882,110.27H216.6l-9.145,41.6h75.575Z",
    transform: "translate(-80.537 -110.27)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M287.7,158.656H193.868l-14.979,62.08h123.79Z",
    transform: "translate(-76.081 -117.818)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6272",
    "data-name": "Group 6272",
    transform: "translate(125.343 40.953)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 57.152,
    height: 7.537,
    transform: "translate(10.784)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 60.233,
    height: 7.694,
    transform: "translate(9.243 6.837)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 63.314,
    height: 7.851,
    transform: "translate(7.703 14.071)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 66.395,
    height: 8.008,
    transform: "translate(6.162 21.502)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 69.476,
    height: 8.165,
    transform: "translate(4.622 29.131)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 72.557,
    height: 8.322,
    transform: "translate(3.081 36.958)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 75.638,
    height: 8.479,
    transform: "translate(1.541 45.18)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 78.719,
    height: 8.636,
    transform: "translate(0 53.205)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6273",
    "data-name": "Group 6273",
    transform: "translate(146.306 0.106)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 26.713,
    height: 4.979,
    transform: "translate(5.04)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 28.153,
    height: 5.082,
    transform: "translate(4.32 4.516)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 29.593,
    height: 5.186,
    transform: "translate(3.6 9.294)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 31.033,
    height: 5.29,
    transform: "translate(2.88 14.203)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 32.473,
    height: 5.393,
    transform: "translate(2.16 19.242)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 33.913,
    height: 5.497,
    transform: "translate(1.44 24.411)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 35.353,
    height: 5.601,
    transform: "translate(0.72 29.843)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 36.794,
    height: 5.704,
    transform: "translate(0 35.143)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M312.03,231.7H153.844l-25.252,93.193h208.69Z",
    transform: "translate(-68.234 -129.214)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M359.818,338.656H83.741L57.077,443.774H386.483Z",
    transform: "translate(-57.077 -145.9)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6274",
    "data-name": "Group 6274",
    transform: "translate(38.284 192.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M336.917,349.23H129.122l.707-10.384H336.21Z",
    transform: "translate(-106.601 -338.845)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M339.072,362.006H125.989l.743-10.723h211.6Z",
    transform: "translate(-106.112 -340.786)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M341.258,374.964H122.812l.781-11.069H340.477Z",
    transform: "translate(-105.616 -342.753)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M343.476,388.108H119.588l.82-11.425H342.656Z",
    transform: "translate(-105.113 -344.748)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M345.726,401.442H116.318l.861-11.789H344.865Z",
    transform: "translate(-104.603 -346.772)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M348.057,415.917H112.929l.9-12.175h233.32Z",
    transform: "translate(-104.074 -348.97)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M350.425,430.619H109.487l.949-12.572h239.04Z",
    transform: "translate(-103.537 -351.202)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M352.831,445.555H105.99l1-12.98H351.835Z",
    transform: "translate(-102.992 -353.468)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M355.275,460.728H102.438l1.045-13.4H354.23Z",
    transform: "translate(-102.438 -355.77)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6275",
    "data-name": "Group 6275",
    transform: "translate(89.182 102.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 109.659,
    height: 11.028,
    transform: "translate(20.691)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 115.571,
    height: 11.258,
    transform: "translate(17.735 10.004)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 121.483,
    height: 11.487,
    transform: "translate(14.779 20.587)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 127.394,
    height: 11.717,
    transform: "translate(11.824 31.46)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 133.306,
    height: 11.947,
    transform: "translate(8.868 42.622)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 139.218,
    height: 12.176,
    transform: "translate(5.912 54.074)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 145.13,
    height: 12.406,
    transform: "translate(2.956 66.105)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 151.041,
    height: 12.636,
    transform: "translate(0 77.846)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Shine",
    transform: "translate(106.593 30.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6279",
    "data-name": "Group 6279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6277",
    "data-name": "Group 6277"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x1: 7.552,
    y2: 6.639,
    transform: "translate(19.721 108.4)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 62.574,
    y2: 55.01,
    transform: "translate(31.922 49.302)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x1: 42.729,
    y2: 15.612,
    transform: "translate(45.194 47.659)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x1: 27.428,
    y2: 2.286,
    transform: "translate(21.364 41.265)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x1: 28.677,
    y2: 2.39,
    transform: "translate(51.851 38.62)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 7.107,
    y1: 2.244,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x1: 59.215,
    y1: 18.699,
    transform: "translate(9.152 2.89)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x1: 5.72,
    y1: 1.806,
    transform: "translate(72.342 22.845)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6278",
    "data-name": "Group 6278",
    transform: "translate(125.721)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 7.552,
    y2: 6.639,
    transform: "translate(67.223 108.4)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 62.574,
    y2: 55.01,
    transform: "translate(0 49.302)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 42.729,
    y2: 15.612,
    transform: "translate(6.574 47.659)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 27.428,
    y2: 2.286,
    transform: "translate(45.704 41.265)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 28.677,
    y2: 2.39,
    transform: "translate(13.969 38.62)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y1: 2.244,
    x2: 7.107,
    transform: "translate(87.389)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    y1: 18.699,
    x2: 59.215,
    transform: "translate(26.13 2.89)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y1: 1.806,
    x2: 5.72,
    transform: "translate(16.434 22.845)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(170.709 168.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6285",
    "data-name": "Group 6285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M241.246,213.894s-3.381-1-3.182,1.988,3.779,4.973,3.779,4.973Z",
    transform: "translate(-205.448 -197.386)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M266.307,213.854s2.784-1.393,2.784,1.193-2.983,5.171-2.983,5.171Z",
    transform: "translate(-209.825 -197.346)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M241.336,202.717s.2,14.121.994,16.707,3.183,5.966,5.37,5.966,9.546-.6,10.939-1.392a8.6,8.6,0,0,0,3.58-6.762c0-3.183.4-11.138.4-11.138a6.355,6.355,0,0,0,1.989-2.585c.8-1.79-1.989-4.376-2.586-4.575s-2.784-.8-2.784-.8,1.392-1.193.994-2.188-4.177-1.591-5.768-1.591a8.7,8.7,0,0,0-3.58,1.193s-6.364-.2-8.353,2.188A5.627,5.627,0,0,0,241.336,202.717Z",
    transform: "translate(-205.936 -194.364)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M263.052,233.622l-25.457.4s1.193-3.779,2.585-4.177,15.713-.8,18.7-.4S263.052,233.622,263.052,233.622Z",
    transform: "translate(-205.377 -199.811)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M257.152,433.384s-1.076,11.559-.159,11.926,3.671,1.653,10.279,0c1.754-.438-1.468-12.3-1.468-12.3S261.532,435.591,257.152,433.384Z",
    transform: "translate(-208.345 -231.596)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M220.958,327.151l3.366,50.321s-2.02,9.256-.168,17.5,4.88,37.193,4.88,37.193,1.515-2.861,6.564-3.366,6.059,1.515,6.059,1.515-.337-21.879-.337-24.4,2.02-18.513,1.851-23.393a70.993,70.993,0,0,0-1.346-10.434L243,341.625l2.692-.337s-1.851,25.077-.673,30.8,4.038,23.561,4.207,25.076,2.356,19.522,2.356,19.522,4.375,1.178,6.395,1.009a5.573,5.573,0,0,0,3.366-1.683s3.7-27.1,3.366-31.3-4.207-14.306-4.207-15.147S259.5,363,259.5,363s7.068-19.691,8.246-26.76,1.347-10.265,1.347-10.265-20.028,3.2-29.957,3.2A85.3,85.3,0,0,1,220.958,327.151Z",
    transform: "translate(-202.781 -214.896)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6280",
    "data-name": "Group 6280",
    transform: "translate(23.182 151.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M231.694,385.576a64.787,64.787,0,0,1,8.44-5.993",
    transform: "translate(-227.638 -375.172)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M226.888,390.517s.883-.848,2.328-2.1",
    transform: "translate(-226.888 -376.55)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y1: 7.106,
    x2: 10.536,
    transform: "translate(3.675)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M269.091,325.974s-20.028,3.2-29.957,3.2a85.3,85.3,0,0,1-18.176-2.02l.2,2.995c2.913,2.2,8.1,6.217,12.355,10.117a51.117,51.117,0,0,0,9.269,7.115l.223-5.753,2.692-.337s-1.851,25.077-.673,30.8c.543,2.636,1.442,7.843,2.272,12.842,1.233-3.905,3.606-8.579,7.966-9.03a12.333,12.333,0,0,1,7.842,1.956c-1.191-3.916-2.6-7.787-2.6-8.294,0-.841-1.009-6.563-1.009-6.563s7.068-19.691,8.246-26.76S269.091,325.974,269.091,325.974Z",
    transform: "translate(-202.781 -214.896)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6281",
    "data-name": "Group 6281",
    transform: "translate(4.757 102.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M212.61,315.672s1.242,2.346,2.07,2.622,1.518,2.76,1.518,5.245-.828,2.76-.828,2.76a3.869,3.869,0,0,1,.69,3.312c-.552,1.794-4.141,3.036-5.658,3.588s-3.865-1.932-4.83-3.173-.276-11.179-.276-11.179S212.058,317.052,212.61,315.672Z",
    transform: "translate(-205.057 -315.672)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M216.412,327.778s-2.76,1.1-3.174,1.38-1.932-1.518-1.38-2.07a29.288,29.288,0,0,1,2.622-1.932",
    transform: "translate(-206.099 -317.152)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M210.572,322.376s2.9.69,1.932,3.313",
    transform: "translate(-205.917 -316.718)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M212,329.407s-2.9,1.1-2.9,2.209,1.38,2.484,2.208,2.345-.138-1.242-.138-1.242",
    transform: "translate(-205.688 -317.815)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6282",
    "data-name": "Group 6282",
    transform: "translate(75.101 108.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M293.373,322.376a27.521,27.521,0,0,0-3.036,4.278c-.69,1.518-2.07,2.9-1.794,3.865s.414,1.656.414,1.656-1.242,2.9,0,3.726a4.972,4.972,0,0,0,2.76.966c.552,0,2.76,1.794,4.278,1.518s3.726-.966,3.864-5.658.69-10.075.69-10.075S295.581,322.376,293.373,322.376Z",
    transform: "translate(-288.405 -322.376)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M289.059,333.527s3.725,2.345,4.83,2.345a1.566,1.566,0,0,0,1.1-2.484,28.479,28.479,0,0,0-3.174-2.346",
    transform: "translate(-288.507 -323.728)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M297.436,327.609s-2.208,2.484-1.38,5.244",
    transform: "translate(-289.569 -323.192)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M296.58,334.8s2.622.69,2.76,1.518-.138,2.208-.69,2.208-.828-.965-.828-.965",
    transform: "translate(-289.68 -324.315)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6283",
    "data-name": "Group 6283",
    transform: "translate(0 32.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M288.724,307.385a7.8,7.8,0,0,1-3.38,3.577c-2.39,1.194-6.565-1.989-6.565-1.989L274.4,283.315,264.857,269l-.8,20.879s3.781,23.072,3.183,23.473-9.347,4.371-24.063,5.967-27.647-5.37-27.647-5.37l6.163-23.874-2.783-17.7-6.863,10.753.9,18.482s-1.588,4.174-4.371,4.772a13.836,13.836,0,0,1-5.377,0,.373.373,0,0,0-.008-.063c-.024-.117-.063-.385-.126-.786-.031-.181-.063-.385-.1-.621-.055-.37-.126-.794-.2-1.274-.063-.361-.118-.747-.189-1.163s-.133-.842-.2-1.3v-.008c-1.077-6.682-2.806-17.5-2.94-18.457v-.04c0-1.871,12.932-35.171,13.718-35.957.8-.794.8-3.38,3.584-5.173s17.7-7.955,17.7-7.955c5.762-1.792,21.673.6,21.673.6s6.17,3.577,6.965,3.978,9.347,5.565,11.336,6.76,2.186,3.38,2.979,5.967,6.565,21.68,8.356,25.061S288.724,307.385,288.724,307.385Z",
    transform: "translate(-199.421 -232.927)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M212.046,288.367l.9,18.482s-1.588,4.174-4.371,4.772a13.837,13.837,0,0,1-5.377,0,.374.374,0,0,0-.008-.063c-.024-.117-.063-.385-.126-.786-.031-.181-.063-.393-.1-.621-.055-.37-.126-.794-.2-1.274-.056-.361-.118-.747-.189-1.163s-.133-.841-.2-1.3v-.008c-1.077-6.682-2.806-17.5-2.94-18.457v-.04c1.148.645,3.286,1.7,4.646,1.454,1.046-.188,2.3-1.572,3.223-2.79.181-.559.33-.975.417-1.219,1-2.673,6.831-18.883,6.831-18.883l4.37,11.14Z",
    transform: "translate(-199.421 -238.16)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x2: 3.58,
    y2: 18.497,
    transform: "translate(15.909 20.954)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M279.8,260.46l-2.852,12.832,5.967-12.729",
    transform: "translate(-211.516 -237.222)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x1: 0.455,
    y2: 2.046,
    transform: "translate(68.956 18.17)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M249.613,262.7s11.536,21.082,13.723,22.475",
    transform: "translate(-207.251 -237.572)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 1.569,
    y2: 1.391,
    transform: "translate(54.715 49.397)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 7.346,
    y2: 6.515,
    transform: "translate(45.743 41.44)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M301.036,314.307s-.322-7.544-.88-15.279c-3.447-1.182-7.408-2.841-8.865-4.61-2.784-3.381-12.927-17.1-12.927-17.1l.021.43,8.332,12.5,4.376,25.656s4.176,3.183,6.563,1.989A7.768,7.768,0,0,0,301.036,314.307Z",
    transform: "translate(-211.737 -239.851)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6284",
    "data-name": "Group 6284",
    transform: "translate(23.567 213.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M230.032,451.173l-.367,5.989s-2.937,4.038-2.2,6.241,3.671,1.836,8.077,1.836,7.526-3.12,7.526-5.873-.41-10.043-.41-10.043-1.881-1.691-6.059-1.515A9.26,9.26,0,0,0,230.032,451.173Z",
    transform: "translate(-227.344 -447.795)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M242.28,464.664a5.942,5.942,0,0,0-5.532-1.041c-3.222,1.074-5.163,3.04-7.534,3.659,1.415.538,3.689.38,6.617.38A8.064,8.064,0,0,0,242.28,464.664Z",
    transform: "translate(-227.636 -450.218)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Trophy",
    transform: "translate(189.912 48.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6289",
    "data-name": "Group 6289"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 4.52,
    height: 19.26,
    transform: "translate(23.092 23.916)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M257.658,107.182H244.294l1.572-7.468h10.219Z",
    transform: "translate(-225.624 -59.878)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M264.226,111.016H234.747l3.144-6.878h23.19Z",
    transform: "translate(-224.135 -60.569)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M232.589,56.7A10.615,10.615,0,1,0,243,67.308,10.515,10.515,0,0,0,232.589,56.7Zm0,18.528a7.917,7.917,0,1,1,7.769-7.916A7.844,7.844,0,0,1,232.589,75.224Z",
    transform: "translate(-222.173 -53.167)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M269.846,56.7a10.615,10.615,0,1,0,10.416,10.612A10.515,10.515,0,0,0,269.846,56.7Zm0,18.528a7.917,7.917,0,1,1,7.769-7.916A7.843,7.843,0,0,1,269.846,75.224Z",
    transform: "translate(-227.985 -53.167)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M249.777,82.2h0A13.167,13.167,0,0,1,236.61,69.031V55.471h26.334v13.56A13.167,13.167,0,0,1,249.777,82.2Z",
    transform: "translate(-224.425 -52.976)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6288",
    "data-name": "Group 6288",
    transform: "translate(12.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6286",
    "data-name": "Group 6286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M241.345,63.606l5.565,9.85,1.475-3.3,3.615.588-7.554-9.473Z",
    transform: "translate(-237.976 -53.881)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M240.631,62.659l-1.938,11.146,3.231-1.615,2.423,2.746.162-12.115Z",
    transform: "translate(-237.562 -54.098)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M248.66,58.169a5.653,5.653,0,1,0-5.653,5.654A5.654,5.654,0,0,0,248.66,58.169Z",
    transform: "translate(-237.353 -52.515)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M247.607,58.408a4.361,4.361,0,1,0-4.361,4.362A4.361,4.361,0,0,0,247.607,58.408Z",
    transform: "translate(-237.592 -52.754)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6287",
    "data-name": "Group 6287",
    transform: "translate(4.377 2.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M242.539,56.483a.884.884,0,0,0,.982-.714h.6v5.677h-.892V57.115h-.69Z",
    transform: "translate(-242.539 -55.769)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clouds",
    transform: "translate(46.608 26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6290",
    "data-name": "Group 6290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M299.344,211.909c-.676-3.834-1.652-13.351,4.137-18.019,7.349-5.927,12.566,4.742,18.968-3.557s8.3-26.317,27.266-26.081,20.391,10.907,20.391,14.463,5.69,6.164,6.875,6.164,7.825-3.082,10.2,3.794.764,10.853,4.531,11,8.447-4.994,13.576-2.424,5.129,8.023,7.263,9.919,5.69-1.423,10.433.474c2.873,1.149,3.74,2.991,3.98,4.267Z",
    transform: "translate(-90.828 -47.568)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M309.892,67.948c-.222-1.26-.543-4.388,1.36-5.921,2.415-1.948,4.129,1.558,6.233-1.169s2.727-8.648,8.959-8.57,6.7,3.584,6.7,4.753,1.87,2.026,2.259,2.026,2.572-1.013,3.351,1.247.251,3.567,1.489,3.614,2.776-1.641,4.46-.8,1.685,2.637,2.387,3.259,1.869-.467,3.428.156a1.9,1.9,0,0,1,1.307,1.4Z",
    transform: "translate(-92.528 -30.101)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M297.924,128.752c-.413-2.339-1.008-8.145,2.523-10.992,4.484-3.616,7.666,2.893,11.571-2.169s5.062-16.054,16.633-15.91,12.439,6.653,12.439,8.823,3.471,3.761,4.195,3.761,4.773-1.88,6.218,2.313.466,6.621,2.764,6.71,5.153-3.047,8.282-1.48,3.128,4.894,4.43,6.051,3.471-.868,6.364.29a3.529,3.529,0,0,1,2.428,2.6Z",
    transform: "translate(-90.638 -37.495)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M211.126,46.991c.3-1.689.728-5.88-1.822-7.937-3.238-2.61-5.535,2.089-8.354-1.566S197.3,25.9,188.941,26s-8.981,4.8-8.981,6.37-2.507,2.715-3.028,2.715-3.446-1.358-4.491,1.67-.336,4.78-2,4.845-3.72-2.2-5.98-1.068-2.259,3.534-3.2,4.368-2.506-.626-4.595.209a2.548,2.548,0,0,0-1.753,1.88Z",
    transform: "translate(-68.377 -26)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M209.511,178.537c.832-4.722,2.033-16.44-5.094-22.188-9.05-7.3-15.473,5.839-23.355-4.379s-10.218-32.405-33.573-32.113-25.106,13.429-25.106,17.808-7.007,7.59-8.466,7.59-9.634-3.8-12.554,4.671-.94,13.364-5.579,13.543-10.4-6.148-16.716-2.985-6.315,9.879-8.942,12.214-7.007-1.752-12.846.584c-3.538,1.415-4.606,3.683-4.9,5.255Z",
    transform: "translate(-52.38 -40.642)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M159.679,129.285c.263-1.5.644-5.206-1.614-7.025-2.865-2.312-4.9,1.848-7.4-1.387s-3.236-10.261-10.631-10.169-7.95,4.253-7.95,5.64-2.219,2.4-2.681,2.4-3.05-1.2-3.974,1.48-.3,4.232-1.767,4.288-3.293-1.947-5.293-.945-2,3.128-2.832,3.867-2.219-.555-4.068.185a2.256,2.256,0,0,0-1.552,1.664Z",
    transform: "translate(-61.357 -39.214)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessGoals);
export default __webpack_public_path__ + "static/media/Business_Goals.10eb592a4c7633e71adfde8cb60d63bb.svg";
export { ForwardRef as ReactComponent };